export const SHOW_NOTIFICATION = 'notifications/SHOW_NOTIFICATION'
export const HIDE_NOTIFICATION = 'notifications/HIDE_NOTIFICATION'
export const FETCH_NOTIFICATIONS = 'notifications/FETCH_NOTIFICATIONS'
export const CREATE_NOTIFICATION = 'notifications/CREATE_NOTIFICATION'
export const CREATE_PERMANENT_NOTIFICATION = 'notifications/CREATE_PERMANENT_NOTIFICATION'
